/* eslint-disable @typescript-eslint/no-explicit-any */
import {ITracerLog} from '@apptracer/sdk';

const levels = [
  'debug',
  'info',
  'warn',
  'error',
  'log',
  'assert',
  'trace',
] as const;

const formatArgs = (args: any[]): string =>
  args
    .map((arg) =>
      arg instanceof Error
        ? `${arg.name}: ${arg.message}`
        : typeof arg === 'string'
          ? arg
          : JSON.stringify(arg),
    )
    .join(', ');

export default function writeConsoleToLog(logger: ITracerLog) {
  try {
    levels.forEach((level) => {
      const originalFn = (console as any)[level];
      (console as any)[level] = (...args) => {
        try {
          logger.log(`console.${level}: ` + formatArgs(args));
          originalFn.apply(console, args);
        } catch {
          // empty
        }
      };
    });
  } catch (e) {
    logger.log(`failed to patch console: ` + e?.message);
  }
}
